<script>
	export default {
		props: ['item', 'detailed'],
		data() {
			return {
				mapOptions: {
					settings: {
						scrollwheel: false,
					},
				},
			};
		},
	};
</script>

<template src="./bo-list-item.html"></template>



// WEBPACK FOOTER //
// bo-list-item.vue?96496410